import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckIcon from 'material-design-icons/action/svg/production/ic_check_circle_24px.svg';

import c from './PasswordRules.less';

export default class PasswordRules extends React.Component {
  static propTypes = {
    errors: PropTypes.array,
    rules: PropTypes.array,
    isDirty: PropTypes.bool,
  };

  static defaultProps = {
    errors: [],
    rules: [],
    isDirty: false,
  };

  render() {
    const { rules, errors, isDirty } = this.props;

    return (
      <div className={c.container}>
        <span>Your password must have:</span>
        <ul>
          {rules.map((rule) => {
            const isValid = (
              (isDirty && errors === null)
            || (isDirty && errors ? !errors.includes(rule) : false)
            );

            return (
              <li key={rule} className={classNames(c.ruleItem, { [c.valid]: isValid })}>
                {isValid ? <CheckIcon className={c.icon} /> : null}
                {' '}
                {rule}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
